import './CompressionProgressBar.css';

const CompressionProgressBar = ({ progress = 0 }) => (
    <div className="compression-progress-container">
        <div className="progress-bar-header">
            <span>Compressione in corso...</span>
            <span className="progress-perc">{progress}%</span>
        </div>
        <div className="progress-bar-background">
            <div
                className="progress-bar-foreground"
                style={{ width: `${progress}%` }}
            />
        </div>
    </div>
);

export default CompressionProgressBar;
